import * as types from '../constants/actionTypes';
import _ from 'lodash';

const INITIAL_STATE = {},
    id = iteratee => {
        return iteratee.id;
    }
;

export default function users(state = INITIAL_STATE, action) {
    switch (action.type) {
        case types.DROPBOX__USERS__REQUESTED__SUCCEEDED: {
            const { dropbox, users } = action.payload;

            return {
                ..._.mapKeys(users.entities, id),
                dropbox: parseInt(dropbox),
            };
        }

        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/usersReducer.js
 **/